module.exports = __webpack_public_path__ + "img/LIMPIEZA.38011bd7.png";